import { Typography } from 'components/Contentful'
import { AchieveLink } from 'components/AchieveLink'

const DirectMailerLink = ({ content: mailerContent, track }) => {
  return (
    <div className={'flex items-center'}>
      <AchieveLink
        className={'text-white hover:underline hover:underline-offset-[2.4px]'}
        href={mailerContent.linkHref}
        track={track}
        underline="hover"
      >
        <Typography
          variant="bodySm"
          fontWeight="bold"
          content={mailerContent?.linkText?.json?.content?.[0]?.content?.[0]?.value}
        />
      </AchieveLink>
    </div>
  )
}

export { DirectMailerLink }
